import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import {
    map,
    share,
    catchError,
    withLatestFrom,
    switchMap,
} from 'rxjs/operators';
import { Action, Store } from '@ngrx/store';
import { StockIpoOfferingAction } from './stock-ipo-offering.action';
import { HttpHeaders } from '@angular/common/http';
import { UsersState } from '@toro/common/shared/state-management/users/users.reducer';
import { HttpService } from '@toro/common/shared/services/http/http.service';
import { SettingsService } from '@toro/common/shared/services/settings/settings.service';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';


@Injectable()
export class StockIpoOfferingEffects {
    constructor(
        private actions$: Actions<Action>,
        private store: Store<AppState>,
        private httpService: HttpService,
        private settings: SettingsService,
    ) { }

    @Effect()
    public getAllIpoOfferings: Observable<any> = this.actions$
        .pipe(
            ofType(StockIpoOfferingAction.getAllIpoOfferings),
            withLatestFrom(this.store.select((authStore) => authStore.authentication)),
            switchMap(([_, auth]) => {
                const apiUrl = this.settings.getConfigurationKeyValue('ipoBackendUrl');
                const isLogged = !!(auth.currentUser && auth.currentUser.token);
                return this.httpService.get(`${apiUrl}/ipo.offerings`, this._createHeaders(auth, isLogged))
                    .pipe(
                        map((ipoOfferingResponse: any) => {
                            if (ipoOfferingResponse) {
                                return {
                                    type: StockIpoOfferingAction.getAllIpoOfferingsSuccess,
                                    payload: ipoOfferingResponse
                                }
                            }
                        })
                    );
            }),
            catchError((error) => of({ type: StockIpoOfferingAction.getAllIpoOfferingsError, payload: error })),
            share());

    private _createHeaders(userData: UsersState, logged: boolean = false) {
        if (!logged) {
            return new HttpHeaders({
                'Content-Type': 'application/json; charset=UTF-8',
                'X-SessionID': `${userData.sessionID}`,
            });
        } else {
            return new HttpHeaders({
                'Content-Type': 'application/json; charset=UTF-8',
                'Authorization': `Bearer ${userData.currentUser.token}`,
            });
        }
    }
}
